import { isEmpty } from "lodash";
import { action, computed, makeObservable, observable } from "mobx";
import { AmountToPay } from "core/types/business-details";
import { BaseStore } from "./base.store";
import PaymentsStore from "./payments.store";

class AmountToPayStore extends BaseStore {
    amountToPay: AmountToPay | null = null;

    constructor() {
        super();

        makeObservable(this, {
            amountToPay: observable,
            hasAmountToPay: computed,
            hasAmountToPayBeenSet: computed,
            updateAmountToPay: action
        });
    }

    updateAmountToPay(value: AmountToPay) {
        this.amountToPay = value;
        this.isPopulated = true;
    }

    reset() {
        super.reset();
        this.amountToPay = null;
    }

    get hasAmountToPayBeenSet() {
        return !isEmpty(this.amountToPay);
    }

    get hasAmountToPay() {
        return this.hasAmountToPayBeenSet && (this.amountToPay?.value ?? 0) > 0;
    }
}

export const hasRecentPaymentBeenMade = () => PaymentsStore.recentPayment.value === "true";

export default AmountToPayStore;
